import { getEnv } from './getEnv';

const { VITE_WEB_BASE_URL } = getEnv();

export function generateReviewSchema(reviews) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Pata',
    url: VITE_WEB_BASE_URL,
    review: reviews.map((review) => ({
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: review.name,
      },
      reviewBody: review.body,
      datePublished: review.date,
    })),
  };

  return schema;
}
